import { general } from './general';

export const email = (data = {}) => general('email', (data || {}));
